module.exports = __webpack_public_path__ + "assets/img/visa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/visa.png
// module id = 123
// module chunks = 0